// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PanelFooter":"bcv_a bhn_b bhn_va bhn_rv bhn_rw bhn_vu","PanelFooter--link":"bcv_b"};